import { LocalDictionaryFactory } from '../../api/api.module'

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { TASK_SERVICE_NAME, TaskService } from '../../../services/task'
import { GRID_SERVICE_NAME, GridService } from '../../../services/grid'
import { SYSTEM_SERVICE_NAME, SystemService, $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { DEVICE_SERVICE_NAME, DeviceService } from '../../../services/device'

import { LoggerService } from '../../common/common.module'
import { TaskDetailsDirectiveController } from './tasks-details.directive.controller'
import { ATTACHMENT_SERVICE_NAME, AttachmentService } from '../../../services/attachments'
import { TECHNICAL_PERMISSION_SERVICE_NAME, TechnicalPermissionService } from '../../../services/technical-permission/'
import { TASK_TECHNICAL_PERMISSIONS_SERVICE_NAME, TaskTechnicalPermissionsService } from '../../../services/task/'
import { REFERENCE_TYPE_SERVICE_NAME, ReferenceTypeService } from '../../../services/reference-type/reference-type.service';

// #region Asset Imports

import * as TEMPLATE from './tasks-details.tpl.html'
import './tasks-details.scss'

// #endregion


// #region Setup

export class TaskDetailsDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'logger',
        'localDictionary',
        USER_SESSION_SERVICE_NAME,
        TASK_SERVICE_NAME,
        GRID_SERVICE_NAME,
        SYSTEM_SERVICE_NAME,
        DEVICE_SERVICE_NAME,
        ATTACHMENT_SERVICE_NAME,
        TECHNICAL_PERMISSION_SERVICE_NAME,
        TASK_TECHNICAL_PERMISSIONS_SERVICE_NAME,
        REFERENCE_TYPE_SERVICE_NAME,
        (
            $scope: any,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            logger: LoggerService,
            localDictionary: LocalDictionaryFactory,
            userSessionService: UserSessionService,
            taskService: TaskService,
            gridService: GridService,
            systemService: SystemService,
            deviceService: DeviceService,
            attachemntService: AttachmentService,
            technicalPermissionService: TechnicalPermissionService,
            taskTechnicalPermissionsService: TaskTechnicalPermissionsService,
            referenceTypeService: ReferenceTypeService
        ) => new TaskDetailsDirectiveController(
            $scope,
            $q,
            $timeout,
            logger,
            localDictionary,
            userSessionService,
            taskService,
            gridService,
            systemService,
            deviceService,
            attachemntService,
            technicalPermissionService,
            taskTechnicalPermissionsService,
            referenceTypeService,
            TaskService.REFERENCE_TYPE,
            TaskService.SIMAX_MODULE_NAME
        )]
    controllerAs = '$ctrl'
    template = TEMPLATE
}

// #endregion